import React, { useState } from "react";

const WeatherSearch = () => {

    const currentTime = () => new Date().toString()
    const [weather, setWeather] = useState([])
    const [location, setLocation] = useState([])
    const [observation, setObservation] = useState([])
    const [formData, setFormData] = useState({
        location: "",
    })

    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        })
    }

    const renderResult = (response) => {
        const forecastItems = response.forecasts.map((forecast) => 
            <table key={forecast.date}>
                <thead>
                    <tr>
                        <th>Day</th>
                        <th>Low</th>
                        <th>High</th>
                        <th>Clouds</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{forecast.day}</td>
                        <td>{forecast.low} Degree</td>
                        <td>{forecast.high} Degree</td>
                        <td>{forecast.text}</td>     
                    </tr>
                </tbody>
            </table>
        )
        setWeather(forecastItems)

        const renderLocation = (
                <div key={response.location.city} className="weather-container">  
                    <h1>{response.location.city}, {response.location.region} Weather</h1>
                    <p>{currentTime()}</p>
                </div>
        )
        setLocation([...location, renderLocation])
        
        const renderObservation = (
                    <div key={response.current_observation.astronomy.sunrise} className="current-observation">
                        <h5>Sunrise: {response.current_observation.astronomy.sunrise}</h5>
                        <h5>Sunset: {response.current_observation.astronomy.sunset}</h5>
                        <h6>{response.current_observation.condition.text} - {response.current_observation.condition.temperature} Degree</h6>
                    </div> 
        )
        setObservation([...observation, renderObservation])
    }


    const handleSubmit = (event) => {
        event.preventDefault()
        fetch(`https://yahoo-weather5.p.rapidapi.com/weather?location=${formData.location}&format=json&u=f`, {
            "method": "GET",
            "headers": {
                "x-rapidapi-key": `${process.env.REACT_APP_WEATHER_API_KEY}`,
                "x-rapidapi-host": "yahoo-weather5.p.rapidapi.com"
            }
        })
        .then(response => response.json())
        .then(response => {
            renderResult(response)
        })
        .catch(err => {
            console.error(err);
        });
    }

    return(
        <div>
            <div className="weather-search-form">
                <div className="search-form">
                    <h3 id="weather-text">Search Weather</h3>
                    <hr></hr>
                    <form className="search-box" onSubmit={handleSubmit}>
                        <input className="search-input" type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Enter location..." />
                        <button type="submit"><i className="fas fa-search"></i></button>
                    </form>
                </div>
            </div>
            <div className="weather-info">
                <div id="location">
                    {location}
                    {observation}
                </div>
                {weather}
            </div>
        </div>
            )
        }

export default WeatherSearch;
